import { useEffect } from "react"
import { Route, Routes, useLocation } from "react-router"
import { usePlatform } from "./platform/context"
import { Dashboard } from "./routes/dashboard"
import { Download } from "./routes/download"
import { Home } from "./routes/home"
import { Layout } from "./routes/layout"
import { Login } from "./routes/login"
import { OriginManage } from "./routes/origin/manage"
import { Register } from "./routes/register"
import PublicSharePage from "./routes/share/$shareToken"
import { ProjectId } from "./routes/projects/$projectId"

const ShellViewportBehavior = () => {
	const location = useLocation()
	const platform = usePlatform()

	useEffect(() => {
		const searchParams = new URLSearchParams(location.search)
		const isMacShell =
			platform.kind === "electron" || searchParams.get("origin") === "mac"

		document.documentElement.classList.toggle("origin-mac-shell", isMacShell)
		document.body.classList.toggle("origin-mac-shell", isMacShell)

		return () => {
			document.documentElement.classList.remove("origin-mac-shell")
			document.body.classList.remove("origin-mac-shell")
		}
	}, [location.search, platform.kind])

	return null
}

export const App = () => {
	return (
		<>
			<ShellViewportBehavior />
			<Routes>
				<Route element={<Layout />}>
					<Route index path="/" element={<Home />} />
					<Route path="/download" element={<Download />} />

					<Route path="/login" element={<Login />} />
					<Route path="/register" element={<Register />} />

					<Route path="/dashboard" element={<Dashboard />} />
					<Route path="/origin/manage" element={<OriginManage />} />
					<Route path="/origin/runtime" element={<OriginManage />} />
				</Route>
				<Route path="/projects/:projectId" element={<ProjectId />} />
				<Route path="/share/:shareToken" element={<PublicSharePage />} />
			</Routes>
		</>
	)
}

export default App
